export default __webpack_public_path__ + "static/media/84_photo.68855563.jpg";